import React from 'react';
import { IconStyle } from './icon.styles';

const Icon = ({ children }) => {
  return <IconStyle>{children}</IconStyle>;
};

export default Icon;
